import React from "react";
import {Link} from "@inertiajs/react";
import {useLaravelReactI18n} from "laravel-react-i18n";

export default function Breadcrumbs({pageName, breadcrumbs}) {
    const {t} = useLaravelReactI18n();

    return (
        <div className="breadcrumbs">
            {
                breadcrumbs.map((item) => {
                    return (
                        <Link key={crypto.randomUUID()} href={item.url ? item.url : '#'}
                            className="breadcrumbs__link" disabled={!item.url}>

                            <span>
                                <b>{item.name}</b>
                                {item.url && <b className="slash" >/</b>}
                            </span>
                        </Link>
                    )
                })
            }
        </div>
    );
}
